module.exports = __webpack_public_path__ + "img/ic_alexa_success.71b28822.png";